import { loadEntity, denormalizeFromState } from '@/helpers/utility';
import * as schemas from '@/schemas';
import cartItemApi from '@/api/cartItem';

const state = {
    loadingCartItemSearch: false,
    amazonProductId: null,
    cartItemSearchResultIds: null,
};

const getters = {
    cartItemSearchResults(state, getters, rootState) {
        if (state.cartItemSearchResultIds === null)
            return null;

        let cartItems = _.filter(state.cartItemSearchResultIds.map(id => rootState.data.cartItems.byId[id]));
        return denormalizeFromState(cartItems, schemas.cartItems);
    },
};

const actions = {
    async searchForCartItems({ commit, dispatch }, { amazonProduct }) {
        commit('CARTITEM_SEARCH_LOADING');
        let cartItems = await cartItemApi.searchForAmazonProduct(amazonProduct);
        let cartItemSearchResultIds = loadEntity({ cartItems });
        commit('CARTITEM_SEARCH_COMPLETE', { amazonProduct, cartItemSearchResultIds });
    },
    clearCartItemSearchResults({ commit }) {
        commit('CLOSE_CARTITEM_SEARCH');
    },
};

const mutations = {
    CARTITEM_SEARCH_LOADING(state) {
        state.loadingCartItemSearch = true;
    },
    CARTITEM_SEARCH_COMPLETE(state, { amazonProduct, cartItemSearchResultIds }) {
        state.loadingCartItemSearch = false;
        state.amazonProductId = amazonProduct.id;
        state.cartItemSearchResultIds = cartItemSearchResultIds;
    },
    CLOSE_CARTITEM_SEARCH(state) {
        state.loadingCartItemSearch = false;
        state.amazonProductId = null;
        state.cartItemSearchResultIds = null;
    }
};

export default {
    state,
    getters,
    actions,
    mutations,
};
